export default "__VITE_ASSET__65117da0__"